import { createRoute } from '@tanstack/react-router';
import { IconUsers } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { CustomerDetail } from './CustomerDetail';
import { ContractList } from './ContractList';
import { CustomerList } from './CustomerList';
import { PipelineBoard } from './PipelineBoard';
import { PipelineInquiry, PipelineInquiryFromTask } from './PipelineInquiry';
import { SalesToday } from './SalesToday';
import { PartnerDetail } from './PartnerDetail';
import { PARTNERS } from './partner';
import { customerApiRoute } from './apiRoute';
import { CONTRACTS, CUSTOMERS, DEALS } from './fixtures';

const crm: EzyModule = {
  nav: { key: 'crm', label: 'Khách hàng', icon: IconUsers, section: 'CRM', items: [{ key: 'today', label: 'Hôm nay', to: '/ezy/today' }, { key: 'customers', label: 'Khách hàng', to: '/ezy/customers' }, { key: 'pipeline', label: 'Cơ hội', to: '/ezy/pipeline' }, { key: 'contracts', label: 'Hợp đồng', to: '/ezy/contracts' }, { key: 'partners', label: 'Đối tác', to: '/ezy/partners/YANGMING' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/today', component: SalesToday }),
    createRoute({ getParentRoute: () => parent, path: '/customers', component: CustomerList }),
    createRoute({ getParentRoute: () => parent, path: '/customers/$customerId', component: CustomerDetail }),
    createRoute({ getParentRoute: () => parent, path: '/pipeline', component: PipelineBoard }),
    createRoute({ getParentRoute: () => parent, path: '/pipeline/$inqId', component: PipelineInquiry }),
    createRoute({ getParentRoute: () => parent, path: '/pipeline/$inqId/task', component: PipelineInquiryFromTask }),
    createRoute({ getParentRoute: () => parent, path: '/contracts', component: ContractList }),
    createRoute({ getParentRoute: () => parent, path: '/partners/$partnerId', component: PartnerDetail }),
  ],
  api: { crmCustomer: customerApiRoute },
  fixtures: (register) => {
    register('crmCustomer', CUSTOMERS);
    register('crmDeal', DEALS);
    register('crmContract', CONTRACTS);
    register('crmPartner', PARTNERS);
  },
};
export default crm;
